import omitDeep from 'omit-deep';

import * as logMessageTypes from '../consts/log/logMessageTypes';
import iccMarketService from '../services/icc/iccMarketService';
import log from '../services/logger/log';
import server from '../services/server/server';
import {setIsConfigInitialized} from '../state/ducks/global';
import {dispatch} from '../state/store';
import helpers from '../utils/helpers';
import appConfig from './appConfig';
import {config} from './config';

const initExternalConfig = async () => {
    try {
        const externalConfigUrl = appConfig.getExternalConfigLinksPath();

        if (externalConfigUrl) {
            const externalConfig = await getExternalConfigData(externalConfigUrl);
            const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

            config.data = helpers.mergeDeep(config.data, externalConfig, {arrayMerge: overwriteMerge});
        } else {
            log.info('externalConfigService: externalConfigPath is missing in market config');
        }
    } catch (e) {
        log.error(`initExternalConfig: error: ${e}`, {logMessageType: logMessageTypes.ICC});
    } finally {
        dispatch(setIsConfigInitialized());
    }
};

const getExternalConfigData = async (url) => {
    const externalConfigLink = await iccMarketService.getMediaUrl({
        mediaNameList: url,
    });
    const externalConfigPath = externalConfigLink[0]?.url;
    const receivedExternalConfig = await server.get(externalConfigPath);
    const filteredConfigData = removeUnConfigurablePropsFromConfig(receivedExternalConfig.data);

    return filteredConfigData;
};

const removeUnConfigurablePropsFromConfig = (data) => {
    const KEYS_TO_OMIT = [
        'app.appVersion',
        'app.backendType',
        'app.baseName',
        'app.env',
        'app.publicUrl',
        'app.yapMode',
        'aws',
        'gam',
        'icc',
        'localization',
        'login',
        'logs',
        'market',
        'muleSoft',
        'scp',
        'storage.externalConfig',
        'purchaseDate.localizations',
    ];
    const result = omitDeep(data, KEYS_TO_OMIT);

    return result;
};

export default {initExternalConfig};
